import React, { useState, useEffect } from "react";
import Button from "../../library/components/Button";
import InputField from "../../library/components/InputField";
import {
  useGetCaptchaServiceQuery,
  useGetCaptchaVerifyQuery,
} from "../../services/captchaService";
import reload from "../../images/reload.svg";
import volume from "../../images/volume.svg";
import { BASE_URLS } from "../../constants/constants";
const CaptchaPage = (props) => {
  const [captchaImage, setCaptchaImage] = useState();
  // const [verifyCaptcha, callVerifyCaptcha] = useState(true);
  // const [captchaArg, setCaptchaArg] = useState(true);
  // const [errorMsg, setErrorMsg] = useState("");
  // const [buttonValue, setButtonValue] = useState(
  //   props?.localLang?.BUTTONS?.VERIFY ? props?.localLang?.BUTTONS?.VERIFY : ""
  // );
  // const {
  //   data: captchaData,
  //   isLoading,
  //   isError,
  //   error,
  // } = useGetCaptchaServiceQuery(captchaArg, {
  //   refetchOnMountOrArgChange: true,
  // });
  // const {
  //   data: captchaVerifyData,
  //   isLoading: cpVerifyLoading,
  //   isError: cpVerifyIsError,
  //   error: captchaError,
  // } = useGetCaptchaVerifyQuery(
  //   { captchaId, id: captchaData?.id },
  //   { skip: verifyCaptcha }
  // );
  // useEffect(() => {
  //   if (captchaData) setCaptchaImage(captchaData);
  // }, [captchaData, isLoading]);
  // useEffect(() => {
  //   if (captchaVerifyData || captchaError) {
  //     props.getCaptchaData(captchaVerifyData || captchaError);
  //     captchaVerifyData?.statusCode !== 200 &&
  //       setErrorMsg("Please Enter Valid Captcha");
  //     captchaVerifyData?.statusCode !== 200 && setCaptchaArg(!captchaArg);
  //     captchaVerifyData?.statusCode === 200 &&
  //       setButtonValue(props?.localLang?.BUTTONS?.VERIFIED);
  //     callVerifyCaptcha(true);
  //   }
  // }, [captchaVerifyData, cpVerifyIsError, isLoading]);
  // const handleVerifyCaptcha = () => {
  //   if (captchaId.length!==0) callVerifyCaptcha(false);
  //   else {
  //     setErrorMsg("Please Enter Captcha");
  //   }
  // };
  // useEffect(() => {
  //   setButtonValue(props?.localLang?.BUTTONS?.VERIFY);
  // }, [props.localLang]);
  // // useEffect(() => {
  // //   // if (props.refreshButtonCalled && props.captchaButton) {
  // //   const { refreshButtonCalled, captchaButton } = props;

  // //   if (!refreshButtonCalled && !captchaButton) {
  // //     props.setRefreshButtonCalled(true);
  // //     props.setCaptchaButton(true);
  // //   }
  // //   // }
  // // }, [captchaArg]);

  const [i, seti] = useState(0);
  useEffect(() => {
    if (props.captchaData) setCaptchaImage(props.captchaData);
  }, [props.captchaData]);

  useEffect(() => {
    if (props.captchaId === "" && i > 0) {
      props.setErrorMsg(props.localLang?.FORM6A?.ERROR?.CAPTCHA);
      seti(0);
    }
    if (props.captchaId !== "") {
      seti(1);
    }
  }, [props.captchaId]);




  const refreshVoice = () => {
    var video = document.getElementById("hls-video");
    var source = document.getElementById("change-src");

    //video?.pause()
    source.setAttribute(
      "src",
      BASE_URLS.CAPTCHA_BASE_URL +
      `api/v1/captcha-service/generateVoiceCaptcha/${captchaImage?.id}`
    );
    video.load();
    video.play();
  };

  return (
    <div
      className={`form-group ${props.style}`}
      // style={
      //   props.buttonDisabled ? { pointerEvents: "none", opacity: "0.5" } : {}
      // }
    >
      {
        captchaImage && (
          // <img src={URL.createObjectURL(captchaData?.captcha)} />
          <div className="row ml-1">
            <div className="col-xs-9   mr-0 p-0 ">
              <img
                src={`data:image/jpg;base64,${props.captchaData.captcha}`}
                alt=""
                style={{ border: "1px solid rgb(137 137 129)" }}
              />
            </div>
            <div className="col-md-3  pl-0 d-flex" style={{width: '34px',flexDirection:"column",justifyContent:"center",alignItems:"baseline" }}>
              <img
                src={reload}
                alt=""
                onClick={() => {
                  props.setCaptchaArg(!props.captchaArg);
                  props.setCaptchaId("");
                  props.setErrorMsg("");
                  // setButtonValue(props?.localLang?.BUTTONS?.VERIFY);
                }}
                className="ml-2"
                style={{ cursor: "pointer", height: "18px" ,width:"18px" }}
              />
               <img
                src={volume}
                alt=""
               onClick={() => {
                  refreshVoice();
                }}
                className="ml-2"
          style={{ marginLeft: "8px", cursor: "pointer",  height: "18px" ,width:"18px", marginTop : "8px" }}
              />
            </div>
          </div>
        )
        //
      }
      <div className="row mt-3">
        <div className={`col-md-12 ${props.captchaLabel}`}>
          <label>
            {props.captchaText} <span style={{ color: "red" }}>*</span>
          </label>
        </div>
      </div>
      <div className="row">
        <InputField
          onpaste={true}
          ondrop={true}
          oncut={true}
          oncopy={true}
          autocomplete="off"
          name="captcha"
          placeholder="Enter Captcha *"
          inputClass="col-md-12 forminputLogin"
          disabled={props.disabled}
          iconclass="fas fa-lock"
          ondrop={true}
          oncopy={true}
          oncut={true}
          autocomplete="off"
          labelClass="col"
          value={props.captchaId}
          maxLength={6}
          onChange={(val) => {
            props.setCaptchaId(val.toLowerCase());
            props.setErrorMsg("");
          }}
        />
        {/* <div className="col-lg-5">
          <Button
            onClick={() => {
              handleVerifyCaptcha();
            }}
            btnClass="save-btn"
            value={buttonValue}
          ></Button>
        </div> */}
      </div>
         {captchaImage?.id &&
          <div>
            <video hidden="hidden" id="hls-video" controls name="media">
              <source
                id="change-src"
                src={BASE_URLS.CAPTCHA_BASE_URL + `api/v1/captcha-service/generateVoiceCaptcha/${captchaImage?.id}`}
                type="audio/wav"
              />
            </video>
          </div>
        }
      {props.error ? (
        // captchaVerifyData && captchaVerifyData?.statusCode !== 200 ? (
        <div className="row">
          <div className="col-lg-5 text-danger">{props.error}</div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default CaptchaPage;
